import $ from 'jquery';

export default () => {
  // this is to remove the edit profile link. instead of editing the theme (won't update then)
  $('.ld-profile-edit-link').remove();
  $('.ld-profile-avatar').remove();
  $('.ld-search-prompt').remove();
};
